import { Button, Spin, Steps } from 'antd';
import {
  FileTextOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import React, { useContext, useState } from 'react';

import { AuthContext } from 'components/Auth/Auth';
import ButtonLink from './ButtonLink';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { isNil } from 'lodash';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import DownloadPDF from 'pages/ProductSFS/DownloadPDF';
import moment from 'moment';

const { Step } = Steps;

export type WizardStepsProps = {
  steps: { stepcomcode: string; key: string }[];
  stepsContent: Record<string, React.ReactChild>;
  direction?: 'horizontal' | 'vertical';
  currentStep?: number;
  className?: string;
  onNext?: () => void;
  onPrev?: () => void;
  onDone?: () => void;
  onCancel?: () => void;
  disableNext?: boolean;
  nextComcode?: string;
  prevComcode?: string;
  doneComcode?: string;
  isLoading?: boolean;
  hideCancel?: boolean;
  hideCancelIcon?: boolean;
  isRecap?: boolean;
  hidebtns?: boolean;
  classNameProp?: string;
};

const WizardSteps = ({
  steps,
  stepsContent,
  direction = 'horizontal',
  currentStep = 0,
  className,
  onNext,
  onPrev,
  onDone,
  onCancel,
  disableNext,
  nextComcode = 'Next',
  prevComcode = 'Previous',
  doneComcode = 'Done',
  isLoading,
  hideCancel,
  hideCancelIcon,
  isRecap,
  hidebtns,
  classNameProp,
  ...otherProps
}: WizardStepsProps) => {
  const totalSteps = steps.length;

  const { getComponentLabel, getComponentConfiguration, pagcode, refresh } =
    useDisplayFrameworkContext();

  const { isInspect } = useContext(AuthContext);

  const filteredSteps = steps.slice(0, -1);

  return (
    <Spin
      spinning={isNil(steps)}
      size="default"
      className="ut-custom-spinner "
      style={{
        position: 'fixed',
        top: '40%',
      }}
    >
      <Steps
        {...otherProps}
        direction={direction}
        current={currentStep}
        className={className ? 'ut-custom-spinner' : ''}
      >
        {/* {(isRecap ? filteredSteps : steps).map((step, index) => (
          <Step title={<GetLabel label={step.stepcomcode} />} key={step.key} />
        ))} */}
        {steps.map((step, index) => (
          <Step title={<GetLabel label={step.stepcomcode} />} key={step.key} />
        ))} 
      </Steps>
      {steps.map((step, index) => (
        <div className="ut-wizard-form mt-7 mb-7" key={index} hidden={index != currentStep}>
          {stepsContent[step.key]}
        </div>
      ))}


      <div className={classNameProp ? classNameProp : 'container-stepper'}>
        <div className="d-flex justify-end">
          {currentStep > 0 && (
            <ButtonLink
              comcode={prevComcode}
              type="text"
              onClick={() => !isInspect && onPrev && onPrev()}
              icon={
                <LeftOutlined onClick={() => isInspect && onPrev && onPrev()} />
              }
              iconPosition="start"
              className={isRecap ? "ut-reset-btn ut-btn-no-border no-box-shadow ml-4" : "ut-custom-prev mr-2 ut-btn-bordred"}
            ></ButtonLink>
          )}

          {currentStep === 0 && !hideCancel && (
            <ButtonLink
              comcode="Cancel"
              type="text"
              // icon={
              //   !hideCancelIcon && (
              //     <LeftOutlined
              //       onClick={() => isInspect && onCancel && onCancel()}
              //     />
              //   )
              // }
              onClick={() => !isInspect && onCancel && onCancel()}
              iconPosition="start"
              className={isRecap ? "ut-reset-btn ut-btn-no-border no-box-shadow ml-4" : "ut-btn-bordred ut-custom-prev mr-2"}
            ></ButtonLink>
          )}

          {currentStep < totalSteps - 1 && (
            <ButtonLink
              type="primary"
              htmlType="button"
              comcode={nextComcode}
              disabled={disableNext}
              onClick={() => {
                !isInspect && onNext && onNext();
              }}
              icon={
                <RightOutlined
                  onClick={() => {
                    isInspect && onNext && onNext();
                  }}
                />
              }
              iconPosition="end"
            ></ButtonLink>
          )}
          {currentStep === totalSteps - 1 &&
            (!isRecap ? (
              <ButtonLink
                type="primary"
                loading={isLoading}
                htmlType="submit"
                comcode={doneComcode}
                onClick={() => {
                  !isInspect && onDone && onDone();
                }}
                icon={
                  <RightOutlined
                    onClick={() => {
                      isInspect && onDone && onDone();
                    }}
                  />
                }
                iconPosition="end"
              ></ButtonLink>
            ) : (

              <>
                {/* <ButtonLink
                  type="primary"
                  comcode="print"
                  htmlType="submit"
                  className="ut-reset-btn ut-btn-no-border no-box-shadow ml-4"
                  onClick={() => console.log('print')}
                  iconPosition="end"
                  icon={<FileTextOutlined />}
                /> */}
                <DownloadPDF
                  pageName={'Recap-' + moment().format('DD-MM-YYYY')}
                  className="ut-reset-btn ut-btn-no-border no-box-shadow ml-4"
                  label='downloadDraft'
                  contentElementId='pdf-content'
                />
                <ButtonLink
                  type="primary"
                  comcode="confirm"
                  htmlType="submit"
                  className="ut-reset-btn ml-4"
                  onClick={() => {
                    !isInspect && onDone && onDone();
                  }}
                  iconPosition="end"
                />
              </>
            ))}
        </div>
      </div>
    </Spin>
  );
};

export default WizardSteps;
